<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Meus Exames</h4>
            <div class="alert alert-info">
              <i class="bx bx-info-circle me-2"></i>
              Página em desenvolvimento
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Meus Exames",
    meta: [{ name: "description", content: "Meus exames" }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Meus Exames",
      items: [
        { text: "Paciente", href: "/patient" },
        { text: "Meus Exames", active: true },
      ],
    };
  },
};
</script>
